import type { FC } from "react";
import { useWorkspaceOptions, type WorkspaceId } from "./workspaces.js";
import { WorkspaceSwitcher } from "./workspaceSwitcher.js";

export interface WorkspaceSwitcherContainerProps {
  currentWorkspaceId: WorkspaceId;
}

export const WorkspaceSwitcherContainer: FC<WorkspaceSwitcherContainerProps> = (
  props,
) => {
  const options = useWorkspaceOptions();

  // Nothing to switch between with a single product available.
  if (options.length <= 1) {
    return null;
  }

  return (
    <WorkspaceSwitcher
      workspaces={options}
      selectedWorkspaceId={props.currentWorkspaceId}
    />
  );
};
